import type { DriveStep } from 'driver.js';

export const sidebarTourSteps: DriveStep[] = [
  {
    element: '[data-onboarding="sidebar-toggle"]',
    popover: {
      title: 'Collapse/Expand',
      description: 'Toggle the sidebar between collapsed (icons only) and expanded (full labels) views. Collapsed mode gives more space for the main content.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-onboarding="sidebar-sections"]',
    popover: {
      title: 'Pipeline Sections',
      description: 'Click any section to filter the dashboard. The badge shows how many cases are in each stage. Orange badges indicate items needing attention.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-onboarding="processing-status"]',
    popover: {
      title: 'Processing Status',
      description: 'Shows how many cases are currently being processed and any errors. The spinner animates when work is in progress.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="active-provider"]',
    popover: {
      title: 'Active AI Provider',
      description: 'Shows the currently active LLM provider, model name, and prompt. Click Settings to change these.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="settings-link"]',
    popover: {
      title: 'Settings',
      description: 'Navigate to the Settings page to configure AI providers and translation prompts.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="theme-toggle"]',
    popover: {
      title: 'Theme Toggle',
      description: 'Switch between light and dark modes. Your preference is saved and persists across sessions.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="sync-btn"]',
    popover: {
      title: 'Salesforce Sync',
      description: 'Manually sync with Salesforce to fetch new cases. Shows a countdown to the next automatic sync (every 30 seconds).',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '[data-onboarding="logout-btn"]',
    popover: {
      title: 'Logout',
      description: 'Sign out of the application. You\'ll need to log in again to access the platform.',
      side: 'right',
      align: 'end',
    },
  },
];
